import React, { useEffect, useState } from "react";
import {
  Input,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useSelector } from "react-redux";
import { uploadCourses } from "../../Redux/CoursesUpload";
import { useDispatch } from "react-redux";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import "./CoursesUpload.css";
import Alert from "@mui/material/Alert";
import { validateFileExtension } from "../../utils/helpers";

const courses = {
  Beginner: [
    "Automation_Engineer",
    "Backend_Developer",
    "FullStack_Engineer",
    "System_Engineer",
    "Web_Developer",
  ],
  Intermediate: [
    "Automation_Engineer",
    "Backend_Developer",
    "FullStack_Engineer",
    "System_Engineer",
    "Web_Developer",
  ],
  Advanced: [
    "Automation_Engineer",
    "Backend_Developer",
    "FullStack_Engineer",
    "System_Engineer",
    "Web_Developer",
  ],
};
const CoursesUpload = () => {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [failureMessage, setFailureMessage] = useState("");
  const [uploadStatus, setUploadStatus] = useState(false);

  const uploadState = useSelector((state) => state.coursesData.statusText);
  const SuccessMessage = useSelector((state) => state.coursesData.success);
  console.log("state", uploadState);
  const ErrorMessage = useSelector((state) => state.coursesData.errorMsg);

  const handleLevelChange = (event) => {
    setSelectedLevel(event.target.value);
    setSelectedCourse(""); // Reset selected course when level changes
    setUploadStatus(false);
  };

  const handleCourseChange = (event) => {
    setSelectedCourse(event.target.value);
    setUploadStatus(false);
  };
  const FileUploader = () => {
    if (file && selectedCourse != "" && selectedLevel != "") {
      const formData = new FormData();
      formData.append("file", file);
      const properties = { selectedCourse, selectedLevel };
      dispatch(uploadCourses(formData, properties));
      setUploadStatus(true);
      setFile(null);
      console.log("formData ", formData);
    } else {
      setFailureMessage("Please Select necessary fields.!");
    }
  };

  const handleFileUpload = (file) => {
    if (validateFileExtension(file, ["csv"])) {
      setFile(file);
    } else {
      setFailureMessage("Please Upload a .csv file");
    }
  };

  const ClearUploader = () => {
    setFile(null);
    setFailureMessage("");
    setSelectedCourse("");
    setSelectedLevel("");
    setUploadStatus(false);
  };
  return (
    <>
      <div className="selection-container">
        <div>
          <FormControl component="fieldset">
            <FormLabel component="legend">Levels</FormLabel>
            <RadioGroup
              aria-label="levels"
              name="levels"
              value={selectedLevel}
              onChange={handleLevelChange}
              sx={{ display: "block" }}
            >
              {Object.keys(courses).map((level) => (
                <FormControlLabel
                  key={level}
                  value={level}
                  control={<Radio />}
                  label={level}
                />
              ))}
            </RadioGroup>
          </FormControl>
          {selectedLevel && (
            <FormControl component="fieldset">
              <FormLabel component="legend">Courses</FormLabel>
              <Select value={selectedCourse} onChange={handleCourseChange}>
                <MenuItem value="">Select Course</MenuItem>
                {courses[selectedLevel].map((course) => (
                  <MenuItem key={course} value={course}>
                    {course}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </div>
        <div className="upload-container">
          <div className="upload-wrapper">
            <div className="upload-form">
              <input
                type="file"
                className="mainData"
                accept=".csv"
                id="file"
                onChange={(e) => {
                  handleFileUpload(e.target.files[0]);
                }}
              />
              <label htmlFor="file" className="file_lable">
                &uArr; Upload File
              </label>
              <span className="file_caption">
                {file != null && selectedCourse != "" && selectedLevel != ""
                  ? file.name
                  : "No File Selected"}
              </span>
            </div>
            <Button
              onClick={FileUploader}
              variant="outlined"
              style={{ color: "blueviolet", border: "1px solid blueviolet" }}
            >
              Submit
            </Button>
            <Button
              onClick={ClearUploader}
              variant="outlined"
              style={{
                color: "blueviolet",
                border: "1px solid blueviolet",
                marginLeft: "20px",
              }}
            >
              Clear
            </Button>
          </div>
        </div>
        {failureMessage && !SuccessMessage && !ErrorMessage ? (
          <Alert severity="warning" className="failuremsg">
            {failureMessage}
          </Alert>
        ) : SuccessMessage &&
          uploadStatus &&
          selectedCourse != "" &&
          selectedLevel != "" ? (
          <Alert severity="success" className="failuremsg">
            {uploadState}
          </Alert>
        ) : (
          ErrorMessage &&
          uploadStatus &&
          selectedCourse != "" &&
          selectedLevel != "" && (
            <Alert severity="error" className="failuremsg">
              {uploadState}
            </Alert>
          )
        )}
        <div id="uploading-notes">
          <p>
            *<span className="Note">Instructions : </span>
            <ol>
              <li>
                For a successful upload, please ensure you've selected the
                appropriate file corresponding to the designated level and
                course. Otherwise, there will be an error in the upload process.
              </li>
              <li>
                Please Upload files having{" "}
                <span style={{ fontWeight: "bold" }}>.csv</span> extension
              </li>
            </ol>
          </p>
        </div>
      </div>
    </>
  );
};

export default CoursesUpload;
